import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import clientApi from '~/clientApi';
import { MANAGER_ENTITY_QUERY_KEY } from '~/queries/keys';
import { selectTalentManager } from '~/selectors/talent-manager';

export interface ManagerResponse {
  '@context': string;
  '@id': string;
  '@type': string;
  id: string;
  name: string;
  email: string;
  agencyName: string;
  lastLogin: string;
  lastActivity: string;
  setting: Setting;
  agency: Agency;
  watchlistId: string;
  registeredAt: string;
  createdAt: string;
  updatedAt: string;
  shareToken: string;
  sharedViews: number;
  enabledControls: string[];
  createdAtAgo: string;
  updatedAtAgo: string;
  isPasswordProtected: boolean;
}

export interface Setting {
  '@id': string;
  '@type': string;
  id: string;
  createdAt: string;
  updatedAt: string;
  createdAtAgo: string;
  updatedAtAgo: string;
}

export interface Agency {
  '@id': string;
  '@type': string;
  id: string;
  name: string;
  totalManagers: number;
  enabled: boolean;
  brandDealsAutoSubmitEnabled: boolean;
  hasBrandDealsManualSubmissions: boolean;
  type: string;
  theming: Theming;
  createdAt: string;
  updatedAt: string;
  shareToken: string;
  sharedViews: number;
  enabledControls: string[];
  createdAtAgo: string;
  updatedAtAgo: string;
  isPasswordProtected: boolean;
}

export interface Theming {
  primaryColor: string;
  secondaryColor: string;
  backgroundColor: string;
}

export function useTalentManager() {
  const manager = useSelector(selectTalentManager);

  return useQuery<ManagerResponse>(
    [MANAGER_ENTITY_QUERY_KEY, manager?.id],
    () => clientApi.managers.read(manager?.id),
    { enabled: !!manager?.id },
  );
}
